import apiService from "./apiServices";


export const saveSmsTemplateService = async(formData, token) => {
    try {

        const response = await apiService('/sms-templates/', 'POST', formData, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Saving SMS Template is failed. Please try again.');
        }
  }

export const getAllSmsTemplateService = async(token, page, size) => {
    try {

    const response = await apiService(`/sms-templates/all?page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);
    return response;
    } catch (error) {
        throw (error?.message || 'Get SMS Template is failed. Please try again.');
    }
}

export const deleteSmsTemplateService = async(token, id) => {
    try {

    const response = await apiService(`/sms-templates/${id}`, 'DELETE', null, null, token);
    return response;
    } catch (error) {
        throw (error?.message || 'Get SMS Template is failed. Please try again.');
    }
}

export const smsTemplateSearchService = async(token, formData, page, size) => {
    try {

    const response = await apiService(`/sms-templates/search?search=${formData}&page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);
    return response;
    } catch (error) {
        throw (error?.message || 'Get SMS Template search is failed. Please try again.');
    }
}
